<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
    <div fxFlex="50">
        <mat-card class="content-card">
            <mat-card-header>
                <mat-card-title>
                    <h5>Customer</h5>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
                    <label fxFlex="35" class="secondary">{{ field.header }}</label>
                    <label fxFlex="65" *ngIf="customer">{{ field.cell(customer) }}</label>
                </div>
                <div class="list-item">
                    <label fxFlex="35" class="secondary">Ident Status</label>
                    <mat-expansion-panel class="orders" >
                        <mat-expansion-panel-header class="orders-header">Orders</mat-expansion-panel-header>
                        <div class="list-item">
                            <span fxFlex="25" *ngFor="let field of ordersFields">
                                <label  *ngIf="customer?.orders" class="secondary" >{{field.header}}</label>
                            </span>
                            <span>&nbsp;</span>
                        </div>
                        <div id="scroll">
                            <div class="list-item" fxLayout="row"  *ngFor="let order of customer?.orders; let i = index">
                                <span fxFlex="25" *ngFor="let field of ordersFields" >
                                    <label *ngIf="field.type !== 'button'">{{field.cell(i)}}</label>
                                    <i *ngIf="field.type === 'button' && !IsNaN(field.cell(i))" class="material-icons cursor-pointer" (click)="downloadAttachment(field.cell(i))" >cloud_download</i>
                                    <i *ngIf="field.type === 'button' && IsNaN(field.cell(i))" class="" >{{field.cell(i)}}</i>
                                </span>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-card-content>
            <mat-card-actions align="end">
                <a mat-raised-button color="primary" (click)="returnBack()">Back</a>
                <a mat-raised-button color="primary" routerLink="edit" *ngIf="editEnabled()">Edit</a>
            </mat-card-actions>
        </mat-card>
        <app-object-comments-view *ngIf="customer" [comments]="comments" [objectId]="customer?.id" [target]="commentsTarget"></app-object-comments-view>
        <app-event-log-view [logs]="logs" *ngIf="showLogs()"></app-event-log-view>
    </div>
    <div fxFlex="50">
        <!-- <mat-card class="content-card"> -->
        <mat-accordion class="content-card mat-card">
            <mat-expansion-panel disabled=true>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Card
                    </mat-panel-title>
                    <mat-panel-title>
                        Status
                    </mat-panel-title>
                    <mat-panel-title>
                      Expiry date
                    </mat-panel-title>
                    <mat-panel-title>
                        Last Payment Reminder
                    </mat-panel-title>
                </mat-expansion-panel-header>
            </mat-expansion-panel>
            <mat-expansion-panel *ngFor="let card of customer?.cards">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{card.product.name}}
                    </mat-panel-title>
                    <mat-panel-title class=" {{card.status == 6 ? 'warning-row' : ''}}">
                        {{card.statusName}}
                    </mat-panel-title>
                    <mat-panel-title>
                        {{card.expireDate | date: 'MM/yy'}}
                    </mat-panel-title>
                    <mat-panel-title>
                        {{card.order.paymentEmailReminders && card.order.paymentEmailReminders[card.order.paymentEmailReminders.length - 1] | date: 'dd.MM.yyyy'}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="list-item" fxLayout="row" *ngFor="let field of cardFields;">
                    <label fxFlex="35" class="secondary">{{ field.header }}</label>

                    <label fxFlex="65" *ngIf="!(field.cell(card).startsWith('&lt;a') || field.cell(card).startsWith('&lt;i'))">
                        {{ field.cell(card) }}
                    </label>
                    <label fxFlex="65" *ngIf="field.cell(card).startsWith('&lt;a')">
                        <a [routerLink]="'../../' + field.cell(card).split(' ')[1]" [queryParams]="field.cell(card).split(' ')[2] != '|' ? {search: field.cell(card).split(' ')[2]} : null">
                            {{ field.cell(card).split(' ')[3]}}
                        </a>
                    </label>
                    <label fxFlex="65" *ngIf="field.cell(card).startsWith('&lt;i')">
                        <a [routerLink]="'../../' + field.cell(card).split(' ')[1]" [queryParams]="field.cell(card).split(' ')[2] != '|' ? {search: field.cell(card).split(' ')[2]} : null">
                            <mat-icon aria-label="View">visibility</mat-icon>
                        </a>
                    </label>
                </div>
                <mat-card-actions align="end" *ngIf="showCardActions()">
                    <a mat-raised-button color="primary" (click)="reorderCard(card.id)">Re-Order</a>
                    <a mat-raised-button color="accent" (click)="closeCard(card.id)">Close Card</a>
                </mat-card-actions>
            </mat-expansion-panel>
        </mat-accordion>
        <!-- </mat-card>     -->
    </div>
  </div>
